import React from "react";
import { useTranslation } from "react-i18next";
import AppModalShell, {
  AppModalButton,
  APP_MODAL_BODY_TEXT_CLASS,
} from "../common/AppModalShell";

const ConfirmModal = ({
  isOpen,
  title,
  message,
  messageNode,
  onConfirm,
  onCancel,
  onSecondary,
  confirmText,
  cancelText,
  confirmButtonClassName,
  cancelButtonClassName,
  confirmButtonVariant = "danger",
  cancelButtonVariant = "secondary",
  hideSecondaryButton = false,
  hideCloseButton = false,
}) => {
  const { t } = useTranslation("events");

  const confirmLabel = confirmText || t("confirm_modal.buttons.confirm");
  const cancelLabel = cancelText || t("confirm_modal.buttons.cancel");

  if (!isOpen) return null;

  const modalFooter = (
    <div className="space-y-3">
      <AppModalButton
        variant={confirmButtonVariant}
        onClick={(e) => {
          if (typeof onConfirm === "function") {
            onConfirm(e);
          }
        }}
        className={confirmButtonClassName || ""}
      >
        {confirmLabel}
      </AppModalButton>
      {!hideSecondaryButton && (
        <AppModalButton
          variant={cancelButtonVariant}
          onClick={() => {
            if (typeof onSecondary === "function") {
              onSecondary();
            } else if (typeof onCancel === "function") {
              onCancel();
            }
          }}
          className={cancelButtonClassName || ""}
        >
          {cancelLabel}
        </AppModalButton>
      )}
    </div>
  );

  return (
    <AppModalShell
      open={isOpen}
      title={title}
      onClose={onCancel}
      closeAriaLabel={t("confirm_modal.header.close_alt")}
      maxWidthClassName="max-w-[32rem]"
      zIndexClassName="z-[13000]"
      rightAction={hideCloseButton ? <span className="h-11 w-11" aria-hidden="true" /> : null}
      footer={modalFooter}
    >
      {messageNode ? (
        <div>{messageNode}</div>
      ) : (
        <p className={`whitespace-pre-line text-center ${APP_MODAL_BODY_TEXT_CLASS}`}>
          {message}
        </p>
      )}
    </AppModalShell>
  );
};

export default ConfirmModal;
